import React, { createContext, useState } from "react";
import ColorPricingCategoryService from "../services/ColorPricingCategoryService";

const initialState = {
  loading: false,
  ColorPricingCategory: [],
};

const ColorPricingCategoryContext = createContext();

const ColorPricingCategoryContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllColorPricingCategory = async () => {
    setState({ ...state, loading: true });
    const data = await ColorPricingCategoryService.getAllColorPricingCategory();
    setState({ ColorPricingCategory: data, loading: false });
  };

  const value = { state, setState, getAllColorPricingCategory };
  return (
    <ColorPricingCategoryContext.Provider value={value}>
      {children}
    </ColorPricingCategoryContext.Provider>
  );
};

const useColorPricingCategoryContext = () => {
  const context = React.useContext(ColorPricingCategoryContext);
  if (context === undefined) {
    throw new Error(
      "ColorPricingCategoryContext must be used within a ColorPricingCategoryContextProvider"
    );
  }
  return context;
};

export { ColorPricingCategoryContextProvider, useColorPricingCategoryContext };
